(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('campus', {
            parent: 'entity',
            url: '/campus',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Campuses'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/campus/campuses.html',
                    controller: 'CampusController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('campus-detail', {
            parent: 'campus',
            url: '/campus/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Campus'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/campus/campus-detail.html',
                    controller: 'CampusDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Campus', function($stateParams, Campus) {
                    return Campus.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'campus',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('campus-detail.edit', {
            parent: 'campus-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campus/campus-dialog.html',
                    controller: 'CampusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Campus', function(Campus) {
                            return Campus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('campus.new', {
            parent: 'campus',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campus/campus-dialog.html',
                    controller: 'CampusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('campus', null, { reload: 'campus' });
                }, function() {
                    $state.go('campus');
                });
            }]
        })
        .state('campus.edit', {
            parent: 'campus',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campus/campus-dialog.html',
                    controller: 'CampusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Campus', function(Campus) {
                            return Campus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('campus', null, { reload: 'campus' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('campus.delete', {
            parent: 'campus',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campus/campus-delete-dialog.html',
                    controller: 'CampusDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Campus', function(Campus) {
                            return Campus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('campus', null, { reload: 'campus' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
